import { useState } from 'react';
import {
  Flex,
  Text,
  Image,
  Modal,
  ModalOverlay,
  ModalBody,
  ModalContent,
  ModalHeader,
} from '@chakra-ui/react';

const InstructionModal = ({ isOpen, onClose }) => {
  const [instruction, setInstruction] = useState("placeholder instruction before being fetched from the api");
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Flex justify={'flex-end'}>
            <Image 
              src={require("assets/svgs/cross.svg").default}
              onClick={onClose}
              width={'24px'}
              height={'24px'}
              _hover={{
                cursor: 'pointer'
              }}
            />
          </Flex>
        </ModalHeader>
        <ModalBody>
        <Flex
          padding={4}
          paddingTop={0}
          direction={'column'}
          alignItems={'center'}
        >
            <Image 
              src={require("assets/svgs/book-black.svg").default}
              width={'42px'}
              height={'42px'}
              marginBottom={4}
            />
            <Text
              fontFamily={'gothicBold'}
              fontSize={32}
              borderBottom="1px solid white"
              marginBottom={4}
            >
              Instructions
            </Text>

            <Text
              fontFamily={'gothic'}
              fontSize={14}
              marginBottom={4}
            >
              {instruction}
            </Text>
        </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default InstructionModal;